module.exports = __webpack_public_path__ + "dbbfc47705054dd809f7dbad229b8248.pdf";